export default __webpack_public_path__ + "static/lifestyle-e888a33d0e43fd4844bd9256bd8054a3.webp";